import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// 语言检测配置
const detectionOptions = {
  order: ["querystring", "localStorage", "navigator", "htmlTag"],
  lookupQuerystring: "lng",
  lookupLocalStorage: "i18nextLng",
  caches: ["localStorage"],
};

// 语言配置
const languageConfig = {
  // 支持的语言（简化到只有中文和英文）
  supportedLngs: ["zh", "en"],
  
  // 默认语言和fallback机制
  fallbackLng: "zh",
  
  // 语言检测
  detection: detectionOptions,
  
  // 后端配置
  backend: {
    loadPath: "/locales/{{lng}}/translation.json",
  },
  
  // 其他优化配置
  load: "languageOnly",
  nonExplicitSupportedLngs: false,
  
  // 调试模式（开发时可开启）
  debug: false,
  
  // 插值配置
  interpolation: {
    escapeValue: false, // React已经处理了XSS防护
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init(languageConfig);
